import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *  selectedCategoryIds: number[] }} SelectedCategoryIds
 */

const api = new Api("api/Projects");

/**
 * @param {number} projectId
 * @returns {Promise<AxiosResponse<SelectedCategoryIds>>}
 */
export const getById = (projectId) =>
  api.get(`${projectId}/results/categories`);

/**
 * @param {number} projectId
 * @param {number[]} selectedCategoryIds
 * @returns {Promise<AxiosResponse<SelectedCategoryIds>>}
 */
export const postById = (projectId, selectedCategoryIds) =>
  api.post(`${projectId}/results/categories`, selectedCategoryIds);
